import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * The notice for a flow the user has just come back from — a GitHub App
 * install, a Stripe Checkout — named by `?{param}=` in the URL.
 *
 * Read once and kept for the page view, while the parameter itself is taken
 * out of the address bar, so a reload does not announce the same return again.
 * An outcome `notices` has no words for shows nothing.
 */
export const useReturnNotice = (
  param: string,
  notices: Readonly<Record<string, string>>,
): string | null => {
  const [params, setParams] = useSearchParams();
  const outcome = params.get(param);
  const [notice] = useState(() =>
    outcome === null ? null : (notices[outcome] ?? null),
  );
  useEffect(() => {
    if (outcome !== null) {
      setParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          next.delete(param);
          return next;
        },
        { replace: true },
      );
    }
  }, [outcome, param, setParams]);
  return notice;
};
